import React, { PureComponent } from 'react';
import track from './tracking';
import TrackingContext from './TrackingContext';

export default function withClickTracking(
  WrappedComponent,
  additionalTrackingProps,
) {
  class ClickTrackingWrapper extends PureComponent {
    render() {
      const { ...childProps } = this.props;

      let composedProps = {
        ...this.context,
        ...childProps.additionalTrackingProps,
        ...additionalTrackingProps,
      };

      delete childProps.additionalTrackingProps;

      let RenderedContent = track(WrappedComponent);

      return (
        <TrackingContext.Provider value={composedProps}>
          <RenderedContent
            {...childProps}
            additionalTrackingProps={composedProps}
          />
        </TrackingContext.Provider>
      );
    }
  }

  return ClickTrackingWrapper;
}
